module.exports = __webpack_public_path__ + "img/head2.18c5349e.png";